// DS: MO 3.7
import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import IdentityVertical from '../User/IdentityVertical';
import DeviationDumbView from '../DeviationViews/Dumbo';
import { getInfoToDisplayImageDeviation } from '../DeviationViews/Dumbo/Image/_helpers';
import { ResourceType } from '../types/resource';
import { isGroup } from '../User/helpers';
import s from './SellerCard.scss';
const MAX_MULTIART_SHOWN = 3;
const SellerCard = ({ user, link, deviations, width, withShopCta, multiArt, className })=>{
    var _user_profile;
    const { t } = useTranslation();
    const biData = BiData({
        evid: 101,
        itemid: user.userId,
        typeid: isGroup(user) ? ResourceType.GROUP : ResourceType.USER,
        sectionname: BiContextProvidedValue
    });
    const rootClassNames = c(s['root'], 'ds-card', multiArt && s['multi-art'], className);
    const multiArtWidth = (width - 8) / 3;
    const background = multiArt && deviations ? /*#__PURE__*/ React.createElement("div", {
        className: s['multi-art-background']
    }, deviations.slice(0, MAX_MULTIART_SHOWN).map((deviation)=>{
        return /*#__PURE__*/ React.createElement(DeviationDumbView, {
            key: deviation.deviationId,
            deviation: deviation,
            width: multiArtWidth,
            height: multiArtWidth,
            greenLikeCrop: true
        });
    })) : /*#__PURE__*/ React.createElement(BackgroundDeviation, {
        deviation: (_user_profile = user.profile) === null || _user_profile === void 0 ? void 0 : _user_profile.profilePic,
        size: withShopCta ? 'medium' : 'large'
    });
    return /*#__PURE__*/ React.createElement(Section, {
        className: rootClassNames,
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'Browse featured'
        }
    }, background, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        role: "presentation",
        "aria-label": t('sellerCard.a11y.linkOverlay.label'),
        href: link || Url.userLink(user.username, USER_PROFILE_SHOP_SUB_PATHS.ALL),
        className: s['link-underlay'],
        biData: biData
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement(IdentityVertical, {
        size: "large",
        user: user,
        avatarClassName: s['avatar'],
        usernameClassName: s['username'],
        withDetails: !multiArt,
        withLinks: !multiArt
    }), withShopCta && /*#__PURE__*/ React.createElement(SolidButton, {
        className: s['cta'],
        size: "small",
        variant: "main",
        href: link || Url.userLink(user.username),
        biData: biData
    }, t('sellerCard.button.label')))));
};
SellerCard.displayName = 'SellerCard';
export default SellerCard;
const getBackgroundUrl = (deviation)=>{
    const info = getInfoToDisplayImageDeviation({
        deviation,
        width: parseInt(s['background-picture-width'])
    });
    if (info) {
        return `url(${info.pickedImage.src})`;
    }
};
const BackgroundDeviation = ({ deviation, size })=>{
    return /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: c(s['single-background'], !deviation && s['no-image'], deviation && deviation.isMature && s['mature-blur'], s[`single-background-${size}`]),
        style: {
            backgroundImage: deviation ? getBackgroundUrl(deviation) : undefined
        }
    });
};

//# sourceMappingURL=SellerCard.js.map